import styled from "styled-components";
import { BodyValue, InfoItem, InfoName, InfoValue, InfoValueText } from "../../../../../components/info-block/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  /* position: relative; */
`
export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top:20px;
  min-width: 0;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;

    & > div {
      width: 100% !important;
      min-width: 0;
      max-width: 100%;
      flex-wrap: wrap;
      gap: 8px;
    }

    ${InfoItem} {
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      min-width: 0;
    }

    ${InfoName},
    ${BodyValue} {
      width: 100%;
      min-width: 0;
    }

    ${InfoValue},
    ${InfoValueText} {
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: break-all;
    }
  }
`
